import { Component, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';

@Component({
    selector: 'app-common-user-form',
    templateUrl: './common-user-form.component.html',
    styleUrls: ['./common-user-form.component.css']
})
@TraceClassDecorator()
export class CommonUserFormComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
